var _root = dcodeIO.ProtoBuf.newBuilder({})['import']({
    "package": "Mall.PayValidate",
    "options": {
        "objc_class_prefix": "MallPayValidate",
        "java_package": "com.asiainno.uplive.proto"
    },
    "messages": [
        {
            "name": "Request",
            "fields": [
                {
                    "rule": "optional",
                    "type": "string",
                    "name": "orderId",
                    "id": 1
                },
                {
                    "rule": "optional",
                    "type": "string",
                    "name": "receipt",
                    "id": 2
                }
            ]
        },
        {
            "name": "Response",
            "fields": [
                {
                    "rule": "optional",
                    "type": "int64",
                    "name": "diamond",
                    "id": 1
                }
            ]
        }
    ]
}).build();

export default _root;


// WEBPACK FOOTER //
// ./js/component/recharge/payresult/validate.pb.js